var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.25C12.9288 11.25 11.25 12.9288 11.25 15C11.25 17.0712 12.9288 18.75 15 18.75C17.0712 18.75 18.75 17.0712 18.75 15C18.75 12.9288 17.0712 11.25 15 11.25ZM15 21.25C11.5487 21.25 8.75 18.4525 8.75 15C8.75 11.5475 11.5487 8.75 15 8.75C18.4513 8.75 21.25 11.5475 21.25 15C21.25 18.4525 18.4513 21.25 15 21.25ZM15 0C6.71625 0 0 6.71625 0 15C0 21.2725 12.5063 40.0137 15 40C17.455 40.0137 30 21.1875 30 15C30 6.71625 23.2838 0 15 0Z",
    fill: "#E3E6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLogo);
export default __webpack_public_path__ + "static/media/Map-Logo.feea73121661157e18485a3e265d52d4.svg";
export { ForwardRef as ReactComponent };